export default class DictConfig {
  /**
   * @type {Object.<string, {name: string, value: any, key: string, [p:string]: any}>}
   */
  map = {}
  list = []
  dictValueList = []
  _valueMap = {} // 私有属性，尽量不要访问
  _listValueMap = {} // 私有属性，尽量不要访问
  constructor (list = []) {
    if (!Array.isArray(list) || (Array.isArray(list) && !list.length)) {
      throw new Error('缺少初始化参数或初始化参数不正确')
    }
    this.list = list
    const map = {}
    const dictValueList = []
    const listValueMap = {}
    list.forEach(item => {
      dictValueList.push(item.value)
      map[item.key] = item
      this._valueMap[item.value] = item
      if (Array.isArray(item.value)) {
        item.value.forEach(valueItem => {
          if (listValueMap.hasOwnProperty(valueItem)) {
            console.error('value为list的初始化数据中包含重复的value,请确定配置是否正确')
            return
          }
          listValueMap[valueItem] = item
        })
      }
    })
    this._listValueMap = listValueMap
    this.dictValueList = dictValueList
    this.map = map
  }

  custom (list = []) {
    if (!list || !Object.values(list).length) {
      const list = JSON.parse(JSON.stringify(this.list)) || []
      return {
        changeName: (changeConfig = []) => {
          if (!Array.isArray(changeConfig) || !changeConfig.length) {
            throw new Error('缺少自定义参数')
          }
          const values = changeConfig.map(item => item.value)
          list.map(item => {
            if (values.includes(item.value)) {
              item.name = changeConfig[values.indexOf(item.value)].name
            }
            return item
          })
          const newDictConfig = new DictConfig(list)
          return {
            end: newDictConfig,
            ...newDictConfig.custom()
          }
        },
        filterMap: (filterConfig = []) => {
          if (!filterConfig || (Array.isArray(filterConfig) && !filterConfig.length)) {
            throw new Error('缺少过滤参数')
          }
          if (!Array.isArray(filterConfig)) {
            filterConfig = [filterConfig]
          }
          const newArray = list.filter(item => {
            return !filterConfig.includes(item.value)
          })
          const newDictConfig = new DictConfig(newArray)
          return {
            end: newDictConfig,
            ...newDictConfig.custom()
          }
        }
      }
    }
    return new DictConfig(list)
  }

  /**
   * @return {{name: string, value: any, key: string, [p:string]: any}}
   */
  getInfo = (value) => {
    if (!this._valueMap[value] && !this._listValueMap[value]) {
      console.error('value值不在初始化数据中')
      return value
    }
    if (this._valueMap[value]) {
      return this._valueMap[value]
    }
    return this._listValueMap[value]
  }

  getName = (value) => {
    if (!this._valueMap[value] && !this._listValueMap[value]) {
      console.error('value值不在初始化数据中')
      return value
    }
    if (this._valueMap[value]) {
      return this._valueMap[value].name
    }
    return this._listValueMap[value].name
  }

  getNameFormList (value) {
    let obj = {
      name: value
    }
    this.list.some((item) => {
      if (item.value.includes(value) && !item.getNameIgnore) {
        obj = item
      }
    })
    return obj.name
  }
}
